import { initializeApp, getApps } from 'firebase/app';
import { getPerformance, trace, PerformanceTrace } from 'firebase/performance';
import { environment } from '../../../environments/environment';

let performanceInitialized = false;

function ensureFirebaseApp(): void {
  if (getApps().length > 0) {
    return;
  }
  initializeApp(environment.firebaseConfig);
}

export function initFirebasePerformance(): void {
  if (performanceInitialized || typeof window === 'undefined') {
    return;
  }
  if (!environment.enableFirebasePerformance) {
    return;
  }
  ensureFirebaseApp();
  getPerformance();
  performanceInitialized = true;
}

export function startTrace(name: string): PerformanceTrace | null {
  if (!environment.enableFirebasePerformance || typeof window === 'undefined') {
    return null;
  }
  ensureFirebaseApp();
  const perf = getPerformance();
  const perfTrace = trace(perf, name);
  perfTrace.start();
  return perfTrace;
}

export function stopTrace(perfTrace: PerformanceTrace | null): void {
  if (!perfTrace) {
    return;
  }
  perfTrace.stop();
}
